import React from "react";
import PropTypes from "prop-types";
//import Loading from "components/Loading";

const PopupLimiteHCanjearLiberar = ({
    execActionConfirm = null,
    cantCupConsumidosLH = 0,
    cantCupTotalLH = 0,
}) => {
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    };

    return (
        <div
            id="message-popup-terms"
            className="white-popup message-popup-simple"
        >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>Cupones Limitados Canje</strong>
                                </p>
                                <div className="text-center mb-4">
                                    <p>
                                        {cantCupConsumidosLH} de tu(s){" "}
                                        {cantCupTotalLH} Cupon(es) con limite
                                        que se encuentra en tu carrito ya no se
                                        encuentran disponibles
                                    </p>
                                </div>
                                <div className="text-center">
                                    <a
                                        href="#"
                                        onClick={(event) =>
                                            handleConfirm(event)
                                        }
                                        className="btn"
                                    >
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PopupLimiteHCanjearLiberar.propTypes = {
    execActionConfirm: PropTypes.func,
    cantCupConsumidosLH: PropTypes.number,
    cantCupTotalLH: PropTypes.number,
};
export default PopupLimiteHCanjearLiberar;
